import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Check if login functionality is enabled.
 * When disabled, login CTAs should redirect to /agentica and show "Explore Agentica" instead.
 */
export function isLoginEnabled(): boolean {
  if (typeof window === "undefined") {
    return process.env.NEXT_PUBLIC_ENABLE_LOGIN !== "false";
  }
  return (process.env.NEXT_PUBLIC_ENABLE_LOGIN ?? "true") !== "false";
}

/**
 * Helper to get the start of week (Sunday) for a given date
 */
export function getWeekStart(date: Date): Date {
  const d = new Date(date);
  const day = d.getDay();
  d.setDate(d.getDate() - day);
  d.setHours(0, 0, 0, 0);
  return d;
}

/**
 * Helper to get the end of week (Saturday) for a given date
 */
export function getWeekEnd(date: Date): Date {
  const d = new Date(date);
  const day = d.getDay();
  d.setDate(d.getDate() + (6 - day));
  d.setHours(23, 59, 59, 999);
  return d;
}

/**
 * Format a date range for display (e.g., "12/1 - 12/7")
 */
export function formatWeekRange(start: Date, end: Date): string {
  const startStr = `${start.getMonth() + 1}/${start.getDate()}`;
  const endStr = `${end.getMonth() + 1}/${end.getDate()}`;
  return `${startStr} - ${endStr}`;
}
